import { getArticleBySlug } from "@/data/articles";
import { getServiceConfig, type ServiceSlug } from "@/data/serviceLocations";
import { resolveGeoRoute } from "@/lib/geoRouteSeo";

export interface SeoLink { href: string; label: string }

const guides: Record<ServiceSlug, string[]> = {
  "dog-fence": ["best-fence-height-large-dogs", "will-a-fence-stop-coyotes"],
  "deer-fence": ["deer-fence-cost-2026", "protect-vegetable-garden-deer-rabbits"],
  "garden-fence": ["protect-vegetable-garden-deer-rabbits"],
  "fence-restoration": ["repair-vs-replace-fence"],
};

export function serviceGuideLinks(slug?: ServiceSlug): SeoLink[] {
  const slugs = slug ? guides[slug] : ["best-fence-height-large-dogs", "will-a-fence-stop-coyotes"];
  return slugs.flatMap(value => {
    const article = getArticleBySlug(value);
    return article ? [{ href: `/learn/${article.slug}`, label: article.title }] : [];
  });
}

/** Curated from the 2026-10-21 GSC report; bounded links, never an alphabetical town dump. */
export const priorityLocationLinks: SeoLink[] = [
  { href: "/locations/connecticut/fairfield/deer-fence", label: "Deer fencing in Fairfield, CT" },
  { href: "/locations/the-hamptons-ny/deer-fence", label: "Deer fencing in the Hamptons, NY" },
  { href: "/locations/hudson-valley-ny", label: "Dog, deer and garden fencing in the Hudson Valley" },
  { href: "/locations/fairfield-county-ct", label: "Fairfield County fence planning and town guides" },
].filter(link => resolveGeoRoute(link.href.split("/").slice(2)) !== null);

/** Infer only explicit subjects, not geography or unverified project experience. */
export function articleServiceLinks(title: string, category: string): SeoLink[] {
  const subject = `${title} ${category}`.toLowerCase();
  const slugs: ServiceSlug[] = [];
  if (/\bdogs?\b|\bcanine\b|\bcoyotes?\b/.test(subject)) slugs.push("dog-fence");
  if (/\bdeer\b/.test(subject)) slugs.push("deer-fence");
  if (/\bgardens?\b|\borchards?\b/.test(subject)) slugs.push("garden-fence");
  if (/\brestoration\b|\brepair\b/.test(subject)) slugs.push("fence-restoration");
  return slugs.flatMap(slug => {
    const service = getServiceConfig(slug);
    return service ? [{ href: service.hubHref, label: service.fullName }] : [];
  });
}